<div class="float-right d-none d-sm-block"><b>Version</b> {{data.versionNumber}} ({{data.versionType}})</div>
<strong>
    <span>Copyright &copy; {{ currentYear }}</span>
    <a
        href="https://sarvanam.com"
        target="_blank"
        rel="noopener noreferrer"
        style="margin: 0"
    >
        Sarvanam Software Pvt. Ltd.</a
    >
</strong>
<span> All rights reserved.</span>
